import { TranslationKey } from './../../../types/translation/TranslationKey';

import React from 'react';
import Grid from '@mui/material/Grid';
import { t } from '../../../types/translation/Translator';
import { classes, TestIdIdentifier, testIds } from '../../../util/identifiers/identifiers.util';

import Modal from '../../../VentoryUI/components/common/Modal/Modal';
import ModalPane from '../../../VentoryUI/components/common/Modal/components/ModalPane';

interface ValidationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  content: string;
  subContent?: string;
  onYes: () => void;
  onNo?: () => void;
  loading?: boolean;
  testId?: TestIdIdentifier;
}

export default function ValidationModal({
  open,
  setOpen,
  title,
  onYes,
  onNo = () => setOpen(false),
  content,
  loading,
  subContent,
  testId,
}: ValidationModalProps) {
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      title={title}
      testId={testId}
      className={classes.validationModal.name}
    >
      <ModalPane
        footerButtons={[
          { text: t(TranslationKey.no).singular.label, onClick: onNo, disabled: loading, testId: testIds.no },
          {
            text: t(TranslationKey.yes).singular.label,
            onClick: onYes,
            testId: testIds.yes,
            loading: loading,
            style: 'secondary',
          },
        ]}
      >
        <Grid container alignContent={'space-between'}>
          <Grid item xs={12} height={'195px'} justifyContent={'center'} display='flex'>
            <Grid container my={'auto'}>
              <Grid item xs={12} textAlign='center'>
                <p className='my-auto text-base font-semibold'>{content}</p>
              </Grid>
              {subContent ? (
                <Grid item xs={12} textAlign='center'>
                  <p className='my-auto text-sm text-gray-500'>{subContent}</p>
                </Grid>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </ModalPane>
    </Modal>
  );
}
